/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetSkillUsageQueryResponse, ReportingControllerGetSkillUsageQueryParams, ReportingControllerGetSkillUsage400, ReportingControllerGetSkillUsage401, ReportingControllerGetSkillUsage403, ReportingControllerGetSkillUsage404 } from "../../models/reportingController/ReportingControllerGetSkillUsage";

function getReportingControllerGetSkillUsageUrl() {
  const res = { method: 'GET', url: `/api/v1/reporting/skills` as const }  
  return res
}

/**
 * @summary Get skills usage for an organization: organization and personal skills created and applied, most-used organization skills, applications per skill, a bucketed series and the previous-period comparison. Honors the date filters.
 * {@link /api/v1/reporting/skills}
 */
export async function reportingControllerGetSkillUsage(params: ReportingControllerGetSkillUsageQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ReportingControllerGetSkillUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetSkillUsage400 | ReportingControllerGetSkillUsage401 | ReportingControllerGetSkillUsage403 | ReportingControllerGetSkillUsage404>, unknown>({ method : "GET", url : getReportingControllerGetSkillUsageUrl().url.toString(), params, ... requestConfig })  
  return res.data
}